import { Dictionary } from 'src/app/core/model/dictionary';
import { RuleSet } from './ruleSet';

export class Channel
{
  public id: number;
  public name: string;
  public description: string;
  public private: boolean;
  public limitedEnrollment: boolean;
  public limitedView: boolean;
  public dashboardEnrollment: boolean;
  public comments: string;
  public createdBy?: string;
  public createdOn?: Date;
  public lastModifiedBy?: string;
  public lastModifiedOn?: Date;
  public status: string;
  public active = true;
  public version: number;
  public statistics?: ChannelStatistics;
  public goals?: any[];
  public bpmId: string;
  public bpmKey: string;
  public bpmName: string;
  public deployedBpmId: string;
  public deployedBpmKey: string;
  public appId: string;
  public groups: any[];
  public users: any[];
  public ruleSets?: RuleSet[];
  public modelId: string;
  public program: any;
  public channelCategory: any;
  public entryRules: any[];
  public updateRules: any[];
  public newStaffMember: string;
  public programName: string;
  public caseManagerAssignmentMode: string;
  public sensitivities: Dictionary[] = [];
  public copyChannelId: number;
  public referral: boolean;
}

export interface ChannelStatistics
{
  id: number;
  version: number;
  openCases: number;
  closedCases: number;
  lateTasks: number;
  updatedOn: string;
  averageDaysToCloseCase: number;
  targetDaysToCloseCase: number;
  casesMetGoal: number;
  casesFailedGoal: number;
}

export class ChannelData
{
  public operation: string;
  public username: string;
  public token: string;
  public root: string;
  public patientLabel: string;
  public channelWorkflowCodeSetId: number;
}
